import { Component } from 'react'
import * as styles from 'styles/unorganized/StickyHeader.css'
import * as debounce from 'lodash/debounce'
import * as cn from 'classnames'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { MapStateToProps } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { isPageWithMaxWidth } from 'helpers/utilsHelpers'
import { State } from 'interfaces/state'

export type StickyHeaderStateProps = {
  hasMaxWidth: boolean
}

export type StickyHeaderOwnProps = {
  isScrolled: () => boolean
  noAnimation?: boolean
  className?: string
}

type StickyHeaderProps =
  & StickyHeaderStateProps
  & StickyHeaderOwnProps

interface StickyHeaderOwnState {
  isSticked: boolean
}

class StickyHeaderComponent extends Component<StickyHeaderProps, StickyHeaderOwnState> {
  state = {
    isSticked: false,
  }

  render () {
    const { children, className, hasMaxWidth, noAnimation } = this.props
    const { isSticked } = this.state
    const headerClassName = cn(styles.stickyHeader, className, {
      [styles.isSticked]: isSticked,
      [styles.maxWidth]: hasMaxWidth,
      [styles.noAnimation]: noAnimation,
    })

    return (
      <header className={ headerClassName } data-qa-marker='sticky-header'>
        { children }
      </header>
    )
  }

  componentDidMount () {
    this.onScroll()
    window.addEventListener('scroll', this.onScrollDebounced)
  }

  componentWillUnmount () {
    this.onScrollDebounced.cancel()
    window.removeEventListener('scroll', this.onScrollDebounced)
  }

  protected onScroll = () => {
    const { isScrolled } = this.props
    const isSticked = isScrolled()
    if (this.state.isSticked !== isSticked) {
      this.setState({ isSticked })
    }
  }

  protected onScrollDebounced = debounce(this.onScroll, 100)
}

type StickyHeaderOwnPropsInner = StickyHeaderOwnProps & RouteComponentProps<{}>

const mapStateToProps: MapStateToProps<StickyHeaderStateProps, StickyHeaderOwnPropsInner> = createSelector(
  (_state: State, props: RouteComponentProps<{}>) => isPageWithMaxWidth(props.location),
  (hasMaxWidth) => ({
    hasMaxWidth,
  }),
)

const StickyHeaderContainerInner = connect<
  StickyHeaderStateProps,
  {},
  StickyHeaderOwnPropsInner
>(mapStateToProps)(StickyHeaderComponent)

const StickyHeader = withRouter(StickyHeaderContainerInner)

export default StickyHeader
